module.exports = __webpack_public_path__ + "img/maxresdefault.8f5cc32b.jpeg";